import React from "react";
import { useCart } from "../context/CartContect";
import { useTranslation } from "react-i18next";

const CartDetails = () => {
  const { cart } = useCart();
  const {t} = useTranslation();
  
  const subtotal = cart?.reduce((total, item) => total + item.quantity * (item.product.price + item.option.reduce((optTotal, opt) => optTotal + (opt.price || 0), 0)), 0);

  return (
    <div className="cart-details">
      <h3>{t("cart_detail")}</h3>
      <p className="cart-description">
        Lorem ipsum dolor sit amet, etur adipiscing elit, sed do.
      </p>

      <div className="cart-items">
        {cart?.map((item, index) => (
          <div className="cart-item">
            <span className="item-name">
              {item.product.name} x {item.quantity}
            </span>
            <span className="item-price">
              € {item.quantity * (item.product.price + item.option.reduce((optTotal, opt) => optTotal + (opt.price || 0), 0))}
            </span>
          </div>
        ))}
        <div className="cart-tax">
          <span>Subtotal</span>
          <span>€{subtotal}</span>
        </div>
        
      </div>
    </div>
  );
};

export default CartDetails;
